module.exports = __webpack_public_path__ + "img/training.8c6d1fc5.png";